import { useQuery } from "@tanstack/react-query";

import { ClientDetailResponse, caseNotesApi } from "@/api";
import { CaseNoteListFilter } from "@/pages/clients/client/components/tabs/notes-tab/CaseNotes.types";
import { QueryKey } from "@/query/Query";

export function useCaseNotes(
  client: ClientDetailResponse,
  searchValue?: string,
  filter: CaseNoteListFilter = CaseNoteListFilter.All
) {
  const appointmentNotesOnly = filter === CaseNoteListFilter.AppointmentNotesOnly;

  const { data } = useQuery({
    queryKey: [QueryKey.ClientCaseNotes, client.clientId, searchValue, appointmentNotesOnly],
    queryFn: () => {
      return caseNotesApi.getCaseNotesByClientId({
        clientId: client.clientId,
        searchParam: searchValue ?? undefined,
        appointmentNotesOnly,
      });
    },
    meta: { loadingScope: "pageContent" },
  });

  return {
    caseNotes: data,
  };
}
